import React, { useEffect, useState } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarContent,
  SidebarHeader,
} from "react-pro-sidebar";
import LinkTwoToneIcon from "@mui/icons-material/LinkTwoTone";
import { GoIssueClosed } from "react-icons/go";
import { useAppSelector } from "../../../useStore";

const RegisterSidebar = ({ setActive, active }) => {
  const [actives, setActives] = React.useState("/registertable");

  useEffect(() => {
    setActive(actives);
  }, [actives, setActive]);


  const { dataAll } = useAppSelector((state: { registration: any }) => state.registration);

  const { dataLoginUser } = useAppSelector((state: { registration: any }) => state.registration);




  const [inputs, setInputs] = useState<any>({
    registereduser: "",
  });

  const registereduser = dataAll?.data?.filter((obj: any) => {
    return obj?.isEnabled === true;
  });


  useEffect(() => {
    setInputs((prevState: any) => {
      return ({
        ...prevState,
        totalUser: registereduser?.length,
      });
    });

  }, [registereduser?.length])


  const registerSidebar = [
    {
      title: "Registered Users",
      icon: <LinkTwoToneIcon />,
      metric: inputs?.totalUser,
      path: "/registertable",
    },
    {
      title: "Logged In Users",
      icon: <GoIssueClosed size={20} />,
      metric: [dataLoginUser]?.length,
      path: "/roletable",
    },
  ];


  return (
    <div id="Sidenavbar">
      <div id="SideBar__container">
        <div className="SideBar__content">
          <ProSidebar>
            <SidebarHeader>
              <h4>Register</h4>
            </SidebarHeader>
            <SidebarContent>
              <Menu>
                {registerSidebar.map((item, i) => (
                  <MenuItem
                    key={i}
                    className="Side__Content"
                    active={item.path === actives}
                    icon={item.icon}
                    suffix={item.metric}
                    onClick={() => setActives(item.path)}
                  >
                    {item.title}
                  </MenuItem>
                ))}
              </Menu>
            </SidebarContent>
          </ProSidebar>
        </div>
      </div>
    </div>
  );
};

export default RegisterSidebar;
